// extracted by mini-css-extract-plugin
module.exports = {"labelContainer":"Label_labelContainer__23xTH","noAlarm":"Label_noAlarm__1yAGt","alarmRaised":"Label_alarmRaised__ZWyPV"};